import Vue from 'vue'
import Vuex from 'vuex'
import { user } from './user'
import { ordering } from './ordering'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    ordering
  }
})
